module.exports = __webpack_public_path__ + "img/q.890b7b02.jpg";